import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { log } from 'console';
import { connect, useSelector } from 'react-redux';
import { findPickupStores } from '../../Redux/actions/store';
import moment from "moment";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function PickupModal(props: any) {
  const pickupStoreList = useSelector((state: any) => state.store.menuPickupStoreList);
  const [filterPickup, setFilterPickup] = useState(pickupStoreList);
  const [query, setQuery] = useState('');
  const [model, setModel] = useState(false);

  const handleQuery = (event: any) => {
    if (query !== "") {
      setQuery(event.target.value);
      let updatedPickupList = pickupStoreList.filter((item: any) => {
        return item.store_name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1;
      });
      setFilterPickup(updatedPickupList)
    } else {
      setQuery(event.target.value);
      setFilterPickup(pickupStoreList)
    }
  };


  useEffect(() => {
    let lat = sessionStorage.getItem("lat")
    let lng = sessionStorage.getItem("lng")
    if (!lat || !lng) {
      toast.info(t("ENABLE_LOCATION_FOR_NEARBY"));
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          sessionStorage.setItem("lat", position.coords.latitude)
          sessionStorage.setItem("lng", position.coords.longitude)
        })
      }
      props.findPickupStores(setModel);
    }
  }, [])

  const { t } = useTranslation();


  return (
    <div>
      <div>
        <input
          type="text"
          value={query}
          onChange={handleQuery}
          className="form-control search-pickup w-100"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder={t("SEARCH")}
        />

        <div className='footer-flow'>
          {query && Array.isArray(filterPickup) && filterPickup.length === 0 && (
            <div className='text-center py-3 store-not-found-msg'>
              {t("STORE_NOT_FOUND")}
            </div>
          )}
          {filterPickup && filterPickup.map((store: any, index: any) => (
            <div
              onClick={() => props.selectStore(store)}
              key={index}
              className='add-address' style={{ backgroundColor: ((props.selectedPickupStore && store.store_id == props.selectedPickupStore.store_id) ? "#e4002b" : "") }}>
              <h5 key={index} style={{ color: ((props.selectedPickupStore && store.store_id == props.selectedPickupStore.store_id) ? "#fff" : "") }}>{store?.store_name}</h5>
              <p style={{ color: ((props.selectedPickupStore && store.store_id == props.selectedPickupStore.store_id) ? "#fff" : "") }}>{store?.address}</p>
              <h5 className='timing' style={{ color: ((props.selectedPickupStore && store.store_id == props.selectedPickupStore.store_id) ? "#fff" : "#e4002b") }}><span>{moment(store?.store_open_time, ["hh:mm:ss"]).format('hh:mm A')} </span>-<span> {moment(store?.store_close_time, ["hh:mm:ss"]).format('hh:mm A')}</span></h5>
              <div className='d-flex justify-content-between align-content-center'>
                {store.distance &&
                  <span className='d-flex align-items-center km-distence'>
                    <h6 className='mb-0' style={{ color: ((props.selectedPickupStore && store.store_id == props.selectedPickupStore.store_id) ? "#fff" : "") }}>{t("DISTANCE_TO_STORE")}:</h6>
                    <h6 className='mb-0' style={{ color: ((props.selectedPickupStore && store.store_id == props.selectedPickupStore.store_id) ? "#fff" : "") }}>{store?.distance} Km</h6>
                  </span>
                }
                <Button onClick={() => window.open("https://maps.google.com?q=" + store.lat + "," + store.lng)}
                  className={`align-items-center d-flex gap-2 justify-content-center px-2 py-1 ${props.selectedPickupStore && store.store_id == props.selectedPickupStore.store_id ? "get-btn" : "bg-theme"}`} variant="contained" color="error"
                >

                  <h6 className='mb-0 get-font'>{t("GET_DIRECTION")}</h6> <i className="ri-direction-fill"></i></Button>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    findPickupStores: function (setState?: any) {
      dispatch(findPickupStores(setState));
    },

  }
}
export default connect(null, mapDispatchToProps)(PickupModal);